import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rating-star",
  "use": "rating-star-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 20\" id=\"rating-star\"><path d=\"M11 15.867l-5.624 3.86a.615.615 0 0 1-.938-.682l1.933-6.54L.962 8.347a.615.615 0 0 1 .359-1.103l6.818-.183L10.42.634a.615.615 0 0 1 1.16 0l2.281 6.428 6.818.183a.615.615 0 0 1 .359 1.103l-5.409 4.156 1.933 6.541a.615.615 0 0 1-.938.682L11 15.867z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol